<template>
  <section class="partners-list">
    <div class="partners-list__main">
      <div v-if="partners.length"
           class="partners-list__list">
        <div v-for="partner in partners"
             :key="partner.customer_data.id"
             class="partners-list__item-wrap">
          <PartnerPreview :partner="partner"
                          @open-agent-registered-show="$emit('open-agent-registered-show', $event)"
                          @click.native="$emit('open-agent', partner)"
                          @refresh="$emit('refresh')"
                          class="partners-list__item"/>
        </div>
        <div class="partners-list__item-wrap _add">
          <PartnerAdd @register-agent="$emit('register-agent')"
                      class="partners-list__item"/>
        </div>
      </div>

      <div v-else
           class="partners-list__empty">
        <picture class="partners-list__empty-bg">
          <source srcset="../../assets/img/partners/empty-small.svg" media="(max-width: 550px)">
          <img src="../../assets/img/partners/empty-big.svg" alt="bg">
        </picture>
        <h3 class="partners-list__empty-title">
          {{ $tPartners('partners_empty_title') }}
        </h3>
        <div class="partners-list__empty-text">
          {{ $tPartners('partners_empty_text') }}
        </div>
        <div class="partners-list__empty-btn-wrap">
          <button @click.prevent="$emit('register-agent')"
                  class="partners-list__empty-btn  base-btn  base-btn--green">
            <BaseSvg name="ico-plus"
                     width="1.1rem"
                     height="1.1rem"/>
            <span>{{ $tPartners('register_agent') }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PartnerPreview from './PartnerPreview'
  import PartnerAdd from './PartnerAdd'


  export default {
    components: {
      PartnerPreview,
      PartnerAdd,
    },
    props: {
      partners: {
        type: Array
      },
    },
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>

<style lang="less">

</style>
